import classnames from 'classnames'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { ContactEven, ContactFiona } from 'embed/constants'
import { formattedPhoneNumber } from 'embed/utils'
import { css } from 'emotion'
import { Brand } from 'even-ts-static'
import * as React from 'react'

const styles = require('./styles')

export interface Props {
  brand?: Brand
}

const EvenCreditDisclosure = (
  <>
    <p>
      The credit card offers that appear on this page are from companies from which Even Financial, Inc. ("Even”, “Even
      Financial”, “we”, “us”, “our”) and its affiliates may receive compensation. The credit card offers that appear on
      www.evenfinancial.com are from credit card companies that pay us compensation. This compensation may impact how
      and where offers appear on this website (including, for example, the order in which they appear). This website
      does not include all credit card companies or all available credit card offers.
    </p>
    <p>
      We do not charge you any fee to submit a credit card request on www.evenfinancial.com. The actual credit card rate
      you may receive depends on the benefits requested, as well as your credit score, usage and history. If you are
      offered a credit card, you will have the opportunity to review and accept the final offer made by the card issuer
      and the card issuer’s credit card agreement. Please note, card issuers’ and their partners’ privacy policies and
      security practices may differ from Even Financial, Inc.'s standards. Even Financial assumes no responsibility, nor
      does it control, endorse or guarantee any aspect of your use of the linked websites for card issuers and their
      partners. All rates, fees, and terms are presented without guarantee and are subject to change pursuant to each
      provider's discretion. There is no guarantee you will be approved or qualify for the advertised rates, fees, or
      terms presented.
    </p>
    <p>
      Annual Percentage Rate (APR) Disclosure: A credit card’s interest rate is the price you pay for using the card and
      borrowing money. For credit cards, the interest rates are typically stated as a yearly rate. This is called the
      Annual Percentage Rate. The higher the APR, the more you’ll pay when using the card. APRs will vary based on your
      credit worthiness, credit limit and other variables, with the lowest APRs available to customers with excellent
      credit. By law, the card issuer must show you the APR on or with your credit card application. We recommend that
      you read the card issuer’s and/or its partner’s terms and conditions in full before proceeding with opening a
      credit card account. Even Financial, Inc. is the technology platform powering financial services online. Even is
      not a bank or credit card issuer.
    </p>
    <p>
      Even’s API enables its partners to connect their users with real-time decisions and personalized offers and rates
      from financial services providers. All decisions and terms offered, are the responsibility of the participating
      credit card issuer. Any trademarks used in connection with products or services appearing on this website are the
      sole property of their respective owners. No affiliation or endorsement is intended or implied. Even Financial
      offices are located at 50 West 23rd Street, Suite 700, New York, NY 10010, Telephone number:{' '}
      {formattedPhoneNumber(ContactEven.Phone)}. This site is directed at, and made available to, persons in the
      continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

const FionaCreditDisclosure = (
  <>
    <p>
      The credit card offers that appear on this page are from companies from which Even Financial, Inc. / Fiona
      ("Even”, “Even Financial”, ”Fiona”, “we”, “us”, “our”) and its affiliates may receive compensation. This
      compensation may impact how and where offers appear on this website (including, for example, the order in which
      they appear). This website does not include a comprehensive list of all credit card companies or all available
      credit card offers.
    </p>
    <p>
      We do not charge you any fee to submit a credit card request on www.fiona.com. The actual credit card rate you may
      receive depends on the selected features , as well as your credit score, usage and history. If you are offered a
      credit card, you will have the opportunity to review and accept the final offer made by the card issuer and view
      the card issuer’s credit card agreement. Please note, card issuers’ and their partners’ privacy policies and
      security practices may differ from Fiona's standards. Fiona assumes no responsibility, nor does it control,
      endorse or guarantee any aspect of your use of the linked websites for card issuers and their partners. All rates,
      fees, and terms are presented without guarantee and are subject to change pursuant to each provider's discretion.
      There is no guarantee you will be approved or qualify for the advertised rates, fees, or terms presented.
    </p>
    <p>
      Annual Percentage Rate (APR) Disclosure: A credit card’s interest rate is the price you pay for using the card and
      borrowing money. For credit cards, the interest rates are typically stated as a yearly rate. This is called the
      Annual Percentage Rate. The higher the APR, the more you’ll pay when using the card. APRs will vary based on your
      credit worthiness, credit limit and other variables, with the lowest APRs available to customers with excellent
      credit. By law, the card issuer must show you the APR on or with your credit card application. We recommend that
      you read the card issuer’s and/or its partner’s terms and conditions in full prior to opening a credit card
      account.
    </p>
    <p>
      Even Financial, Inc. is the technology platform powering financial services online. Even’s API enables its
      partners to connect their users with real-time decisions and personalized offers and rates from financial services
      providers. All decisions and terms offered, are the responsibility of the participating credit card issuer. Any
      trademarks used in connection with products or services appearing on this website are the sole property of their
      respective owners. No affiliation or endorsement is intended or implied. Even Financial offices are located at 43
      West 24th Street, 6th Floor, New York, NY 10010, Telephone number: {formattedPhoneNumber(ContactFiona.Phone)}.
      This site is directed at, and made available to, persons in the continental U.S., Alaska and Hawaii only.
    </p>
  </>
)

export const CreditDisclosure: React.FunctionComponent<Props> = ({ brand }) => (
  <ThemeConsumer>
    {({ fontFamilySecondary }) => (
      <div
        className={classnames(
          css`
            font-family: ${fontFamilySecondary};
          `,
          styles.CreditCardDisclosureGroup,
        )}
      >
        {brand === Brand.Fiona ? FionaCreditDisclosure : EvenCreditDisclosure}
      </div>
    )}
  </ThemeConsumer>
)
